/**
 * Created by asiulik on 15.05.2018.
 */

define(['jquery', 'lodash', 'eventEmitter/EventEmitter', '../../utils', '../../core/cookies'], function($, _, EventEmitter, Utils, CookiesHelper){

    var bookmarkConfig = {
        bookmarkPopupSelector: ".bookmark__popup",
        bookmarkPopupActiveClass: "bookmark__popup--visible",
        bookmarkUrlAttr: "bookmarkDataUrl",
        bookmarkVisibilityTimeout: 500
    };

    //example event

    // var reloadBookmarksContent = document.createEvent('CustomEvent');
    // reloadBookmarksContent.initCustomEvent('reloadBookmarksContent', true, true, {});
    // window.dispatchEvent(reloadBookmarksContent);

    function Bookmarks(layoutInstace){

        var _this = this;

        this.layoutInstace = layoutInstace;
        this.updateProductButtonOnBookmarksChange();

        window.addEventListener('reloadBookmarksContent', function(){
            setTimeout(function () {
                _this.updateBookmarks();
            }, 1000);
        });

    }

    Bookmarks.prototype = _.clone(EventEmitter.prototype);

    Bookmarks.prototype.init = function(){

        var _this = this;

        this.bookmarkPopupVisibilityTimeout = undefined;
        this.$bookmarkPopup = $(bookmarkConfig.bookmarkPopupSelector);

        this.bookmarkDataUrl = this.$bookmarkPopup.data(
            bookmarkConfig.bookmarkUrlAttr
        );

        setTimeout(function(){

            if ( CookiesHelper.getCookie('favourites') === 'initial-code' ) {
                return;
            }

            _this.loadInitialBookmarkData(_this.bookmarkDataUrl).then(function($response) {
                _this.updateTemplate($response.html());
            });

        }, 2000);


        this.bindEvents();
    };

    Bookmarks.prototype.updateTemplate = function($template){
        this.$bookmarkPopup.html($template)
    };

    Bookmarks.prototype.loadInitialBookmarkData = function(url){
        return this.getBookmarkData(url);
    };

    Bookmarks.prototype.getBookmarkData = function(bookmarkDataUrl){

        if ( CookiesHelper.getCookie('favourites') === 'initial-code' ) {
            return;
        }

        var _this = this;

        return $.get(bookmarkDataUrl).then(function(response){
            var $bookmarkContent = $(response).find(bookmarkConfig.bookmarkPopupSelector);
            _this.emit('bookmarkContentLoaded', $bookmarkContent);
            return $bookmarkContent;
        });
    };

    Bookmarks.prototype.updateBookmarks = function(){

        var _this = this;
        var bookmarkDataUrl = this.$bookmarkPopup.attr("data-bookmark-data-url");

        _this.getBookmarkData(bookmarkDataUrl).then(function($response) {
            _this.updateTemplate($response.html());
        });

    };

    Bookmarks.prototype.bindEvents = function(){

        var _this = this;

        this.$bookmarkPopup.on({
            mouseover: function(){
                if(_this.bookmarkPopupVisibilityTimeout) clearTimeout(_this.bookmarkPopupVisibilityTimeout);
                _this.displayPopup();
            },
            mouseout: function(){
                if(_this.bookmarkPopupVisibilityTimeout) clearTimeout(_this.bookmarkPopupVisibilityTimeout);
                _this.hideBookmarkPopup();
            }
        })

    };

    Bookmarks.prototype.displayBookmarkPopup = function(){

        if ( !CookiesHelper.getCookie('favourites') || ( CookiesHelper.getCookie('favourites') == 'initial-code' ) ) {
            return;
        }

        var _this = this;

        if(this.bookmarkPopupVisibilityTimeout) clearTimeout(this.bookmarkPopupVisibilityTimeout);
        this.bookmarkPopupVisibilityTimeout = setTimeout(function(){

            _this.displayPopup();

        }, bookmarkConfig.bookmarkVisibilityTimeout);

    };

    Bookmarks.prototype.hideBookmarkPopup = function(){

        var _this = this;

        if(this.bookmarkPopupVisibilityTimeout) clearTimeout(this.bookmarkPopupVisibilityTimeout);
        this.bookmarkPopupVisibilityTimeout = setTimeout(function(){

            _this.hidePopup();

        }, bookmarkConfig.bookmarkVisibilityTimeout);
    };

    Bookmarks.prototype.displayPopup = function(){
        this.$bookmarkPopup.addClass(bookmarkConfig.bookmarkPopupActiveClass);
    };

    Bookmarks.prototype.hidePopup = function(){
        this.$bookmarkPopup.removeClass(bookmarkConfig.bookmarkPopupActiveClass);
    };

    Bookmarks.prototype.updateProductButtonOnBookmarksChange = function(){

        var _this = this;

        this.on('bookmarkContentLoaded', function($content){
            _this.updateProductButtonState($content);
        });
    };

    Bookmarks.prototype.updateProductButtonState = function($content){
        try {

            var $bookmarkContent = $content || $('.bookmark__popup__content');

            var $productBar = $('.product__bar').length ? $('.product__bar') : $('#rechner-results').closest(".t__content");
            if(!$productBar.length) return;

            var $buttonElement = $productBar.find('[data-fav-id]');
            var favId = $buttonElement.data('favId');

            // var favParamWood = $buttonElement.data('favParamWood');
            // var favParamSurface = $buttonElement.data('favParamSurface');

            var $bookmarskFavItems = $bookmarkContent.find('[data-fav-id]');
            var $foundElement;

            $bookmarskFavItems.each(function(index, bFavitem) {

                var $bFavitem = $(bFavitem);
                var bFavId = $bFavitem.data('favId');
                // var bFavParamWood = $bFavitem.data('favParamWood');
                // var bFavParamSurface = $bFavitem.data('favParamSurface');

                if(favId == bFavId) {
                    $foundElement = $bFavitem;
                }

            });

            $foundElement && $foundElement.length ?
                (function(){
                    $buttonElement.addClass('product__favourite__btn--active')
                    $('#add-to-favourite').addClass('product__favourite__btn--active');
                })() :
                (function(){
                    $buttonElement.removeClass('product__favourite__btn--active');
                    $('#add-to-favourite').removeClass('product__favourite__btn--active');
                })();

        } catch(e){
            console.log('Problem with select active product button state', e);
        }
    }

    return Bookmarks;

});



// WEBPACK FOOTER //
// ./Private/Scripts/modules/bookmarks/bookmarks.js